module.exports = __webpack_public_path__ + "img/9788957982136.20d768f5.jpg";